import React from 'react';
import ReactDOM from 'react-dom';
import {App} from './app';
import 'whatwg-fetch';
import './index.css';

ReactDOM.render(
  <App/>,
  document.getElementById('root')
);
